module.exports = __webpack_public_path__ + "static/experiencia-banner-41855f8354ac8e43d875a2b56ca901f6.svg";